var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hospital-doctor-info-table"},[_c('Commontable',{attrs:{"tableData":_vm.tableData,"headerData":_vm.headerData,"hasChecked":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }